import { Button } from '@/components/atoms/Button/index.ts'
import {
  Toast,
  ToastAction,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/atoms/Toast/Toast.tsx'
import { type ToasterActions, useDashboardAlertToasts } from '@/model/contexts/useDashboardAlertToasts.ts'

import { useToast } from './useToast.ts'

export interface ToasterProps extends ToasterActions {}

export const Toaster = ({ onHighlight, onTeamMessageClick, currentTeamId, onChannelMessageClick }: ToasterProps) => {
  const { toasts: errors } = useToast()
  const { toasts: alerts } = useDashboardAlertToasts({
    onHighlight,
    onTeamMessageClick,
    currentTeamId,
    onChannelMessageClick,
  })

  return (
    <ToastProvider swipeDirection="right">
      {alerts.map(({ id, title, description, actions, variant, ...props }) => (
        <Toast key={id} {...props} variant={variant}>
          <ToastTitle asChild>
            <p className="text-[16px] font-semibold">{title}</p>
          </ToastTitle>
          <ToastDescription>{description}</ToastDescription>
          <ToastAction altText="Actions" asChild className="[grid-area:action]">
            <div className="flex gap-2">
              {actions.map((action) => (
                <Button
                  key={action.label}
                  onClick={action.onClick}
                  size="sm"
                  className="inline-flex h-[28px] items-center justify-center px-2.5 leading-[25px]">
                  {action.label}
                </Button>
              ))}
            </div>
          </ToastAction>
        </Toast>
      ))}
      {errors.map(({ id, title, description, ...props }) => (
        <Toast key={id} {...props} className="mt-2">
          {title && <ToastTitle>{title}</ToastTitle>}
          {description && <ToastDescription>{description}</ToastDescription>}
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  )
}
